import styled, { css } from 'styled-components';

export const WarningModalContentStyled = styled.div`
  ${({ theme }) => {
    const { colors, media } = theme;
    return css`
      padding: 64px 28px;
      text-align: center;
      background-color: ${colors.primary.white};
      border-radius: 32px;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
      position: relative;
      width: 100%;
      max-width: 350px;
      ${media.tablet.up} {
        max-width: 628px;
      }
      .header {
        font-size: 1.25rem;
        line-height: 1.5rem;
        font-weight: 700;
        width: 280px;
        margin: auto;
        margin-bottom: 16px;
        margin-top: 16px;
        ${media.tablet.up} {
          width: 387px;
          font-size: 1.875rem;
          line-height: 2.125rem;
          margin-bottom: 32px;
          margin-top: 32px;
        }
      }
      #warning-icon {
        width: 40px;
        height: 40px;
      }
      .subheader {
        font-size: 1rem;
        line-height: 1.25rem;
        width: 280px;
        margin: auto;
        margin-bottom: 16px;
        ${media.tablet.up} {
          width: 500px;
          margin-bottom: 32px;
        }
      }
      button {
        width: 164px;
        height: 46px;
        background-color: ${colors.primary.red};
        border-radius: 35px;
        color: white;
        border: none;
        cursor: pointer;
        font-size: 1.125rem;
        font-weight: bold;
      }
      .close-btn {
        position: absolute;
        right: 22px;
        top: 22px;
        cursor: pointer;
        height: 12px;
        width: 12px;
        ${media.tablet.up} {
          height: 24px;
          width: 24px;
        }
      }
    `;
  }};
`;
